import React from 'react';
import Layout from '../components/Layout';

import ScrollingText from '../components/lettersslider';
import ServiceComponent from '../components/servicedescrpition';
import ComponentWithCards from '../components/serviceheadings';
import OurService from '../components/servicepage/ourservice';
import ContactForm from '../components/servicecontact';





import ResearchHeader from '../components/researchheader';
import ResearchServices from '../components/researchservices';
import useScrollTransition from '../useScrollTransition';


const ResearchPage = () => {
  useScrollTransition();
  return (
    <Layout>
      
        <ResearchHeader/>
        <ScrollingText/>
        <ResearchServices/>
        <ServiceComponent/>
      <ComponentWithCards/>
      <OurService/>
      <ContactForm/>
        
    </Layout>
  );
};

export default ResearchPage;